'use client';

import { RewardsAppProvider, LoyaltyTermsPage } from '@fanduel/rewards-hub-client';
import { useRewardsHubConfig } from '@/hooks/use-rewards/use-rewards';
import type { RewardsPageConfig } from '@/logic/page-config/rewards/rewards-page-config';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import NotFoundComponent from '@/app/not-found';
import { useAccountUm } from '@/hooks/use-account-um';
import { useStore } from '@/store/store';
import { useEffect, useMemo } from 'react';

type LoyaltyTermsClientProps = { pageConfig?: RewardsPageConfig; isLoggedIn?: boolean };

export const LoyaltyTermsClient: React.FC<LoyaltyTermsClientProps> = ({ pageConfig, isLoggedIn }) => {
    const rewardsConfig = useRewardsHubConfig(pageConfig, isLoggedIn);
    const { triggerLogin } = useAccountUm();
    const handleShowLoading = useStore((s) => s.loading.handleShowLoading);
    const handleHideLoading = useStore((s) => s.loading.handleHideLoading);
    const fetchOptions = useMemo(
        () => ({
            onStart: handleShowLoading,
            onEnd: handleHideLoading
        }),
        [handleShowLoading, handleHideLoading]
    );

    useEffect(() => {
        if (!isLoggedIn) {
            triggerLogin();
        }
    }, [isLoggedIn, triggerLogin]);

    if (!isLoggedIn) {
        return <NotFoundComponent />;
    }

    return (
        <RewardsAppProvider>
            <LoyaltyTermsPage config={rewardsConfig} fetchOptions={fetchOptions} />
        </RewardsAppProvider>
    );
};
